<template>
  <div class="prev" @click="$emit('click')"></div>
</template>

<script>
export default {
  name: "Prev"
};
</script>

<style lang="scss" scoped>
.prev {
  width: 28px;
  height: 28px;
  background-image: url(~/images/箭头1.png);
  background-size: contain;
  cursor: pointer;
}

.prev:hover {
  background-image: url(~/images/箭头1悬停.png);
}
</style>